
import mixin from './mixin';

export default {
  mixins: [mixin],
  props: {
    color: {
      type: String,
      default: '#000000'
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 30
    }
  },
  data: function data() {
    return {
      alphaSize: 5
    };
  },

  watch: {
    color: function color() {
      this.renderColor();
    }
  },
  mounted: function mounted() {
    this.renderColor();
  },

  methods: {
    renderColor: function renderColor() {
      var canvas = this.$el;
      var width = this.width;
      var height = this.height;
      var size = this.alphaSize;
      var canvasSquare = this.createAlphaSquare(size);

      var ctx = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;

      ctx.fillStyle = ctx.createPattern(canvasSquare, 'repeat');
      ctx.fillRect(0, 0, width, height);

      ctx.fillStyle = this.color;
      ctx.fillRect(0, 0, width, height);
    }
  }
};